import { useAppSelector } from "./redux";
import { useEnhanceModal } from "@components/EnhanceModal";
import { LinkData } from "@config";
import { Checkbox } from "antd";
import { useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import classNames from "classnames";
import useCheckSignupProtocal from "./useCheckSignupProtocal";

export const useCheckUsIp = ({ isLogin }: { isLogin: boolean }) => {
  const { checkSignupProtocal } = useCheckSignupProtocal();
  const [checkboxValue, setCheckboxValue] = useState(!checkSignupProtocal);
  const nextFun = useRef<Function>(() => {});
  const { language } = useAppSelector((state) => state.globalReducer);
  const { t } = useTranslation();
  const { EnhanceModalDom, setVisible } = useEnhanceModal({
    title: t("friendly_Reminder"),
    visible: true,
    content: (
      <div>
        <Trans
          i18nKey={isLogin ? "friendly_login_Reminder" : "friendly_register_Reminder"}
          components={{
            1: (
              <a
                className="cursor-pointer mx-1 font-normal"
                href={LinkData["service"][language || "en-US"]}
                target="_blank"
              >
                <Trans>Terms of Service</Trans>
              </a>
            ),
            2: (
              <a
                className="cursor-pointer mx-1 font-normal"
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Trans>Privacy Policy</Trans>
              </a>
            ),
          }}
        ></Trans>
      </div>
    ),
    onConfirm: () => {
      setCheckboxValue(true);
      nextFun.current?.(location.pathname.slice(1));
    },
  });

  const checkISAgreeProtocol = (nextHandle: Function) => {
    if (!checkboxValue) {
      // if (checkSignupProtocal && !checkboxValue) {
      setVisible(true);
      nextFun.current = nextHandle;
      return false;
    }
    return true;
  };
  const usProtocolDom = () => {
    return (
      <div className="mt-[20px]">
        <div className={classNames("us_agree_tip flex items-center text-[#666666] justify-center relative")}>
          <Checkbox
            checked={checkboxValue}
            className="force-checkbox-white-bg"
            onChange={(e: { target: { checked: any } }) => setCheckboxValue(e.target.checked)}
          ></Checkbox>
          <div className="ml-[11px] text-kds-fg-soft">
            <Trans
              i18nKey="agreePolicy"
              components={{
                1: (
                  <a
                    className="cursor-pointer text-kds-fg-soft! font-normal mx-1"
                    href={LinkData["service"][language || "en-US"]}
                    target="_blank"
                  >
                    <Trans>Terms of Service</Trans>
                  </a>
                ),
                2: (
                  <a
                    className="cursor-pointer text-kds-fg-soft! font-normal mx-1"
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Trans>Privacy Policy</Trans>
                  </a>
                ),
              }}
            ></Trans>
          </div>
        </div>

        {EnhanceModalDom}
      </div>
    );
  };

  const usWxcodeProtocolDom = () => {
    return (
      <div className="text-[14px] text-[#666] m-auto mt-[20px] leading-[140%] text-center">
        <Trans
          i18nKey={"wx_friendly_Reminder"}
          components={{
            1: (
              <a
                className="cursor-pointer mx-1 font-normal text-[#222]"
                href={LinkData["service"][language || "en-US"]}
                target="_blank"
              >
                <Trans>Terms of Service</Trans>
              </a>
            ),
            2: (
              <a
                className="cursor-pointer mx-1 font-normal text-[#222]"
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Trans>Privacy Policy</Trans>
              </a>
            ),
          }}
        ></Trans>
      </div>
    );
  };
  return {
    usProtocolDom,
    checkISAgreeProtocol,
    usWxcodeProtocolDom,
  };
};
